import React from 'react';
// import DashboardLayout from '../components/Layouts/DashboardLayout';
import DashboardSidebar from '../components/DashboardComponents/DashboardSidebar';
import InnerBanner from '../components/PagesComponents/InnerBanner';
import BuyerEnquiryInfoList from '../components/DashboardComponents/BuyerEnquiryInfoList';
const BuyerEnquiry = () => {
 return (
    <>
{/* <InnerBanner pageKey="buyerDashboard" /> */}

      <section className='dashboard'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-12'>
                   <BuyerEnquiryInfoList/> 
                </div>
               
            </div>
        </div>
      </section>
    </>
 );

};

export default BuyerEnquiry;